interface ExampleChipsProps {
  examples: string[];
  onSelect: (example: string) => void;
  label?: string;
}

export default function ExampleChips({ examples, onSelect, label = 'Try an example:' }: ExampleChipsProps) {
  return (
    <div className="example-chips">
      <span className="example-chips__label">{label}</span>
      <div className="example-chips__list">
        {examples.map((example, index) => (
          <button
            key={index}
            type="button"
            className="example-chip"
            onClick={() => onSelect(example)}
          >
            {example}
          </button>
        ))}
      </div>
    </div>
  );
}
